import React from 'react';
import PropTypes from 'prop-types';

import {Autocomplete, TextField, CircularProgress} from '@mui/material';

import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';

import backend from 'utils/backend';

const AdminAutocomplete = (props) => {
  const [inputValue, setInputValue] = React.useState('');
  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [fetchNewData, setFetchNewData] = React.useState(true);

  const {selectedAdmin, setSelectedAdmin, label, statuses = ['ACTIVE']} = props;

  React.useEffect(() => {
    if (selectedAdmin) {
      setInputValue(`${selectedAdmin.firstName} ${selectedAdmin.lastName}`);
    }
  }, []);

  React.useEffect(() => {
    if (loading) {
      return;
    } else if (fetchNewData ) {
      const fetchData = async () => {
        const localMatches = options.filter((option) =>{
          return (option.firstName + ' ' + option.lastName).toLowerCase().includes(inputValue.toLowerCase());
        });

        // If less than 3 local matches, fetch new data
        if (localMatches.length < 3) {
          setLoading(true);

          try {
            const filter = [];
            // if (inputValue) {
            //   filter.push({key: 'firstName', value: `${inputValue.trim()}*`});
            // }
            filter.push({key: 'status', value: statuses});
            filter.push({key: 'role', value: 'ADMIN'});
            const sortBy = {sortKey: 'createdAt', sortDirection: 'DESC'};

            const result = await backend.user.queryUser(filter, sortBy);

            const list = result.list;
            setOptions(list);
          } catch (e) {
            console.error('Failed to query admin data');
          } finally {
            setLoading(false);
          }
        }
      };
      fetchData();
    }
  }, [inputValue]);

  const handleInputChange = (event, newValue, reason) => {
    if (reason === 'input') {
      setFetchNewData(true);
    } else {
      setFetchNewData(false);
    }
    setInputValue(newValue); // Always update the inputValue for display
  };

  const handleOptionSelect = (event, selectedOption) => {
    if (selectedOption) {
      setSelectedAdmin(selectedOption); // Pass only the id of the selected option to the parent
    }
  };

  return (
    <Autocomplete
      freeSolo
      options={options}
      inputValue={inputValue}
      isOptionEqualToValue={(option, value) => option.userRn === value.userRn}
      value={selectedAdmin ?? null}
      onInputChange={handleInputChange}
      onChange={handleOptionSelect}
      getOptionLabel={(option) => option.firstName + ' ' + option.lastName || ''}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          slotProps={{
            input: {
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps?.endAdornment}
                </>
              ),
            },
          }}
        />
      )}
      renderOption={(props, option) => {
        const matches = match(`${option.firstName} ${option.lastName}`, inputValue ?? '');
        const parts = parse(`${option.firstName} ${option.lastName}`, matches);

        return (
          <li {...props} key={option.userRn}>
            {parts.map((part, index) => (
              <span
                key={index}
                style={{fontWeight: part.highlight ? 700 : 400}}
              >
                {part.text.replace(/ /g, '\u00A0')}
              </span>
            ))}
          </li>
        );
      }}
    />

  );
};

AdminAutocomplete.propTypes = {
  label: PropTypes.object.isRequired,
  selectedAdmin: PropTypes.object,
  setSelectedAdmin: PropTypes.func.isRequired,
  statuses: PropTypes.arrayOf(PropTypes.string),
};

export default AdminAutocomplete;
